import {ValueObject} from '@s-ui/domain'

import {FilterStringSearchValueObject} from './FilterStringSearchValueObject.js'

export class FilterRegionSearchValueObject extends ValueObject {
  #region

  constructor({region}) {
    super()
    this.#region = region
  }

  static create({region}) {
    return new FilterRegionSearchValueObject({region: FilterStringSearchValueObject.create(region)})
  }

  static createWithDefaultValue({config, region}) {
    const {DEFAULT_REGION_SEARCH} = config.get('searchFilters')

    return new FilterRegionSearchValueObject({
      region: FilterStringSearchValueObject.create({string: region ?? DEFAULT_REGION_SEARCH})
    })
  }

  get isEmpty() {
    return this.#region.isEmpty
  }

  get value() {
    return this.#region.value
  }

  toJSON() {
    return {
      region: this.#region.toJSON()
    }
  }
}
